export default function dateFormat(value) {
  const date = new Date(value);

  return date.toLocaleString('en-US', { dateStyle: 'long' });
}
